export const partsPpfSedan = [
  "hood & fenders",
  "front bumper",
  "rear bumper",
  "headlamps",
  "grille",
  "mirrors & door cups",
  "a-pillars & roofline",
  "rockers",
  "luggage area",
];

export const partsPpfTruck = [
  "hood & fenders",
  "front bumper",
  "rear bumper",
  "headlamps",
  "grille",
  "mirrors & door cups",
  "a-pillars & roofline",
  "rockers",
  "tail gate",
];

export const partsPpfSuv = [
  "hood & fenders",
  "front bumper",
  "rear bumper",
  "headlamps",
  "grille",
  "mirrors & door cups",
  "a-pillars & roofline",
  "rockers",
  "luggage area",
];
